import linkToAdminPages from "../links";

export default function linkToCategories() {
  return `${linkToAdminPages()}/categories`;
}
